/**
 * Probleme — pain points adressés par Mon Ministère.
 */
import { colors, fonts } from "../../styles/tokens";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";

const ITEMS = [
  {
    icon: "📓",
    titre: "Le cahier et l'Excel",
    desc: "Données membres éparpillées sur 3 fichiers. Impossible à partager avec l'équipe.",
  },
  {
    icon: "📱",
    titre: "Le chaos WhatsApp",
    desc: "Annonces perdues dans les messages, absences oubliées, dons jamais suivis.",
  },
  {
    icon: "🌍",
    titre: "Le réseau multi-villes",
    desc: "Des antennes à Paris, Abidjan et Montréal ? Impossible d'avoir une vue d'ensemble.",
  },
];

export default function Probleme() {
  const [titleRef, titleStyle] = useScrollFadeIn();

  return (
    <section style={{
      padding: "clamp(64px, 10vw, 100px) clamp(16px, 4vw, 24px)",
      background: colors.bg,
      fontFamily: fonts.body,
      maxWidth: "100vw",
      overflowX: "hidden",
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <h2 ref={titleRef} style={{
          ...titleStyle,
          fontFamily: fonts.heading,
          fontSize: "clamp(32px, 4vw, 48px)",
          fontWeight: 700,
          textAlign: "center",
          color: colors.text,
          marginBottom: "16px",
          letterSpacing: "-0.01em",
        }}>
          Les pasteurs jonglent. <span style={{ color: colors.gold }}>Ça suffit.</span>
        </h2>
        <p style={{
          color: colors.textMuted,
          fontSize: "16px",
          textAlign: "center",
          maxWidth: 600,
          margin: "0 auto 56px",
          lineHeight: 1.6,
        }}>
          Trois symptômes que vous connaissez probablement trop bien.
        </p>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "20px",
        }}>
          {ITEMS.map((it, i) => (
            <Card key={it.titre} item={it} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ item, delay }) {
  const [ref, style] = useScrollFadeIn({ delay });
  return (
    <div ref={ref} style={{
      ...style,
      padding: "28px 24px",
      background: colors.card,
      border: `1px solid ${colors.border}`,
      borderRadius: "16px",
    }}>
      <div style={{ fontSize: "40px", marginBottom: "12px" }}>{item.icon}</div>
      <h3 style={{
        fontFamily: fonts.heading,
        fontSize: "22px",
        fontWeight: 600,
        color: colors.text,
        marginBottom: "10px",
      }}>
        {item.titre}
      </h3>
      <p style={{ color: colors.textMuted, fontSize: "14px", lineHeight: 1.6 }}>
        {item.desc}
      </p>
    </div>
  );
}
